import { render, staticRenderFns } from "./DeviceShareEditDialog.vue?vue&type=template&id=060f7807&scoped=true"
import script from "./DeviceShareEditDialog.vue?vue&type=script&lang=ts"
export * from "./DeviceShareEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./DeviceShareEditDialog.vue?vue&type=style&index=0&id=060f7807&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060f7807",
  null
  
)

export default component.exports